import { BaseReducer } from '@identic/api';
import { BreedState, BreedInitialState, BreedActions } from './breed.state';

export function BreedReducer(state: BreedState = BreedInitialState, action: any): BreedState {
  return BaseReducer(state, action, BreedActions);
}
// console.log(`%cBreedReducer::ngOnInit`, 'background:yellow');
